// This function allow to reference chunks
__webpack_require__.miniCssF = function(chunkId) {
  // return url for filenames not based on template
  if (chunkId === "7888") return "css/design_system-d1021fa2cbdc8ecd.css";
if (chunkId === "2128") return "css/2128-c4fb6e03132e1a07.css";
if (chunkId === "4662") return "css/4662-44eccc0403d5f3f3.css";
  // return url for filenames based on template
  return "css/" + chunkId + "-" + {"2196": "6a4fa745f2459857","2429": "a73d2fa285645c40","3531": "cf702b05f37031f5","4170": "d7df7df552b688b7","7364": "a8d311b114ec77ce",}[chunkId] + ".css"
}